import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { RefreshIcon, DeleteIcon } from 'foundations-assets';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { useMemo, useState } from 'react';
import PermanentlyDeleteModal from 'email-management-lib/EmailArchiveOrDelete/components/PermanentlyDeleteModal';
import RestoreModal from 'email-management-lib/EmailRestore/components/RestoreModal';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import useHasAllScopes from 'messaging-management-lib/user/hooks/useHasAllScopes';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function DeletedViewBulkActions({
  selectionMode,
  selectedObjects
}) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isRestoreModalOpen, setIsRestoreModalOpen] = useState(false);
  const isAllEmailsInCurrentViewSelected = useMemo(() => selectionMode === 'all', [selectionMode]);
  const hasAllScopes = useHasAllScopes();
  const isSuperAdmin = hasAllScopes('super-admin');
  if (isAllEmailsInCurrentViewSelected) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonWrapper, {
      "data-test-id": "deleted-view-bulk-actions",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(RefreshIcon, {
          color: "do-not-use-eerie"
        }), /*#__PURE__*/_jsx(Button, {
          size: "extra-small",
          use: "link",
          onClick: () => setIsRestoreModalOpen(true),
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.actions.names.restore"
          })
        })]
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: isSuperAdmin,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.permanentlyDeleteTooltip"
        }),
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(DeleteIcon, {
            color: "do-not-use-eerie"
          }), /*#__PURE__*/_jsx(Button, {
            disabled: !isSuperAdmin,
            size: "extra-small",
            use: "link",
            onClick: () => {
              setIsDeleteModalOpen(true);
            },
            marginInlineStart: "100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.actions.names.permanentlyDelete"
            })
          })]
        })
      })]
    }), isDeleteModalOpen && /*#__PURE__*/_jsx(PermanentlyDeleteModal, {
      crmObjects: selectedObjects,
      onClose: () => setIsDeleteModalOpen(false)
    }), isRestoreModalOpen && /*#__PURE__*/_jsx(RestoreModal, {
      crmObjects: selectedObjects,
      onClose: () => setIsRestoreModalOpen(false),
      listingLibObserver: listingLibObserver
    })]
  });
}
export default DeletedViewBulkActions;